<script module>
  /**
   * @typedef {Object} Meta
   * @property {string?} [title]
   * @property {string?} [description]
   * @property {Prismic.FilledImageFieldImage?} [image]
   * @property {string?} [robots]
   */

  /** @type {function(Meta): void} */
  export function setMeta(value) {
    const { title, description, image, robots } = value
    Object.assign(meta, { title, description, image, robots })
  }

  /** @type {Meta} */
  export const meta = $state({})
</script>

<script>
  import { page } from '$app/state'

  /** @type {{ root?: boolean } & Meta} */
  let { root, ...props } = $props()

  if (!root) {
    setMeta(props)
  }

  let name = $derived(
    page.data.settings
      ? !meta.title
        ? page.data.settings.data.name
        : `${meta.title.replace(/(\n|\s)+/g, ' ')} • ${
            page.data.settings.data.name
          }`
      : meta.title || ''
  )
</script>

{#if root}
  <title>{name}</title>
  <meta property="og:title" content={name} />
  <meta property="og:site_name" content={page.data.settings?.data.name} />
  <meta property="og:url" content={page.url.toString()} />

  {#if meta.description}
    <meta name="description" content={meta.description} />
    <meta property="og:description" content={meta.description} />
  {/if}

  {#if meta.image?.url}
    <meta property="og:image" content={meta.image.url} />
    <meta
      property="og:image:width"
      content={String(meta.image.dimensions.width)} />
    <meta
      property="og:image:height"
      content={String(meta.image.dimensions.height)} />
  {:else}
    <meta property="og:image" content={new URL('/share.jpg', page.url).href} />
    <meta property="og:image:width" content="1920" />
    <meta property="og:image:height" content="1080" />
  {/if}

  {#if meta.robots}
    <meta name="robots" content={meta.robots} />
  {/if}
{/if}
